import { MappingTipiEntitaFascicolo } from "src/app/common/configuration/mapping-tipi-entita-fascicolo";
import { MappingTipiEntitaPratica } from "src/app/common/configuration/mapping-tipi-entita-pratica";
import { PdaComboModel, PdaFilterMode } from "../models/consultation/pda-combo-model";

export class PdaUtils {

    public static pdaComboValues: PdaComboModel[] = [
        {
            tipoPratica: "CIVILE",
            filterMode: PdaFilterMode.CATEGORIA_FASCICOLO,
            filterValues: ['GIUDIZIALE', 'ESECUZIONE']
        },
        {
            tipoPratica: 'LAVORO',
            filterMode: PdaFilterMode.CATEGORIA_FASCICOLO,
            filterValues: ['GIUDIZIALE', 'ESECUZIONE']
        },
        {
            tipoPratica: 'AMMINISTRATIVO',
            filterMode: PdaFilterMode.TIPO_FASCICOLO_CASSAZIONE,
            filterValues: ['RICORSO', 'APPELLO']
        },
        {
            tipoPratica: 'TRIBUTARIO',
            filterMode: PdaFilterMode.TIPO_FASCICOLO_CASSAZIONE,
            filterValues: ['ORDINARIO']
        }
    ];


    public static getPdaComboModelbyLabelTipoPratica(label: string): PdaComboModel {
        let values = this.pdaComboValues.filter(pcv => pcv.tipoPratica === label);
        return !!values ? values[0] : null;
    }

    public static checkPdaEnabledSections(fascicolo): boolean {
        console.log("checkPdaEnabledSections [fascicolo]",fascicolo);
        if(!!fascicolo){
            let idTipoPratica = fascicolo.praticaBase?.tipoPratica?.id;
            if(!!idTipoPratica){
                switch(idTipoPratica){
                    case MappingTipiEntitaPratica.PRATICA_AMMINISTRATIVA:
                        return this.checkPdaEnabledAmministrativa(fascicolo);
                    case MappingTipiEntitaPratica.PRATICA_TRIBUTARIO:
                        return this.checkPdaEnabledTributario(fascicolo);
                    case MappingTipiEntitaPratica.PRATICA_CIVILE:
                    case MappingTipiEntitaPratica.PRATICA_LAVORO:
                        return this.checkPdaEnabledDefault(fascicolo);
                    default:
                        console.log("Consultazione PDA non disponibile.");
                        return false;   
                }
            }
        }
        console.log("Consultazione PDA non disponibile.");
        return false;
    }

    public static checkPdaEnabledAmministrativa(fascicolo): boolean {
        let idTipoFascicolo = fascicolo?.tipoFascicolo?.id;
        let autorita = fascicolo?.autoritaGiudiziaria?.label?.toUpperCase();

        let isTipoFascicoloValido =
        [
            MappingTipiEntitaFascicolo.FASCICOLO_RICORSO,
            MappingTipiEntitaFascicolo.FASCICOLO_APPELLO
        ].includes(idTipoFascicolo);

        let isCassazione = autorita === 'CASSAZIONE';

        if ((isTipoFascicoloValido) && isCassazione) {
        console.log('Consultazione PDA disponibile.');
        return true;
        }

        console.log("Consultazione PDA non disponibile.");
        return false;
    }

    

    public static checkPdaEnabledTributario(fascicolo: any): boolean {
        let idTipoFascicolo = fascicolo?.tipoFascicolo?.id;
        if(!!idTipoFascicolo && idTipoFascicolo === MappingTipiEntitaFascicolo.FASCICOLO_ORDINARIO){

            let autorita = fascicolo?.autoritaGiudiziaria?.label?.toUpperCase();
            let isCassazione = autorita === 'CASSAZIONE';

            if (isCassazione) {
            console.log('Consultazione PDA disponibile.');
            return true;
            }

        }

        console.log("Consultazione PDA non disponibile.");
        return false;
    }

    public static checkPdaEnabledDefault(fascicolo: any): boolean {

        let isCategoriaFascicoloValida = [
            'GIUDIZIALE',
            'ESECUZIONE'
        ].includes(
            fascicolo?.tipoFascicolo?.categoria?.id
        );

        if(isCategoriaFascicoloValida){
            console.log("Consultazione PDA disponibile.");
            return true;
        }

        console.log("Consultazione PDA non disponibile.");
        return false;
    }

}